export default "__VITE_ASSET__427d9bba__"